import * as React from 'react';
import {
	AutoSuggestOptions,
	AutoSuggestItem,
	AutoSuggestMenuItemRenderProps,
	AutoSuggestInputProps,
	AutoSuggestRenderMenuProps,
} from './Types';
import { ControllerStateAndHelpers } from 'downshift';

const AutoSuggestContext = React.createContext<Partial<AutoSuggestContextValue>>({
	autoSuggestOptions: {
		allowNewValues: false,
		baseUrl: '',
		staticData: null,
	},
});
export default AutoSuggestContext;

export type AutoSuggestContextValue = AutoSuggestInputProps & {
	autoSuggestOptions: AutoSuggestOptions;
	downshift: ControllerStateAndHelpers<AutoSuggestItem>;
	renderMenuItem: (renderInputProps: AutoSuggestMenuItemRenderProps) => React.ReactNode;
	renderMenu: (renderMenuProps: AutoSuggestRenderMenuProps) => React.ReactNode;
	hideStatusIcon?: boolean;
};
